import React from 'react'
import Logo from '../../assets/images/the-etho-full-logo.png'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'

export default class HeadacheNav extends React.Component {
	toggleCartDrawer = e => {
		e.preventDefault()
		const cartDrawerEl = document.querySelector('#cart-drawer')

		cartDrawerEl.classList.toggle('show')
		document.querySelector('body').classList.toggle('modal-open')
	}

	toggleMobileNav = e => {
		e.preventDefault()
		const mobileMenuEl = document.querySelector('#mmega-menu__container')

		mobileMenuEl.classList.toggle('show')
		document.querySelector('body').classList.toggle('modal-open')
	}

	handleHover = e => {
		let menuToShowAttr = e.currentTarget.id
		Array.from(document.querySelectorAll('[data-subcategory]')).map(
			subcategory => {
				subcategory.classList.remove('show')
				if (subcategory.dataset.subcategory === menuToShowAttr) {
					return subcategory.classList.add('show')
				}

				return null
			}
		)
	}

	componentDidMount() {
		window.addEventListener('scroll', e => {
			document.querySelector('#nav-logo').style.height = `${120 -
				e.target.scrollingElement.scrollTop}px`

			if (e.target.scrollingElement.scrollTop > 30) {
				document.querySelector('#sticky').classList.add('sticky')
			} else {
				document.querySelector('#sticky').classList.remove('sticky')
			}
		})
	}

	render() {
		return (
			<section className='nav-container no-padding'>
				<div className='container'>
					<div
						id='headache'
						className='row hidden-sm hidden-xs pt-3 pb-2 pos--relative'>
						<div id='sticky' className=''>
							<div className='col-12 text-center'>
								<a href='/'>
									<img
										id='nav-logo'
										src={Logo}
										alt='The Etho Logo'
										style={{
											minHeight: '6rem'
										}}
									/>
								</a>
							</div>
							<nav className='col-md-10 pt-2'>
								<ul className='nav-list'>
									<li
										id='nav-item__women'
										className='nav-list__item text-uppercase'>
										<a href='/category'>Women</a>
										<div className='submenu__women submenu-container row'>
											<div className='col-md-4 pos--relative'>
												<ul>
													<li
														id='subcat-clothing'
														onMouseOver={
															this.handleHover
														}>
														Clothing
													</li>
													<li
														id='subcat-shoes'
														onMouseOver={
															this.handleHover
														}>
														Shoes
													</li>
													<li
														id='subcat-bags'
														onMouseOver={
															this.handleHover
														}>
														Bags
													</li>
													<li
														id='subcat-accessories'
														onMouseOver={
															this.handleHover
														}>
														Accessories
													</li>
													<li
														onMouseOver={
															this.handleHover
														}>
														All Women
													</li>
												</ul>
											</div>
											<div className='col-md-4 pos--relative'>
												<ul data-subcategory='subcat-clothing'>
													<li>All Apparel</li>
													<li>Activewear</li>
													<li>Dresses</li>
													<li>Coats + Jackets</li>
													<li>Denim</li>
													<li>
														Lingerie + Loungewear
													</li>
													<li>Pants + Leggings</li>
													<li>Shorts</li>
													<li>Skirt</li>
													<li>Swimwear</li>
													<li>Tops</li>
													<li>All Clothing</li>
												</ul>
												<ul data-subcategory='subcat-shoes'>
													<li>Boots</li>
													<li>Flat Shoes</li>
													<li>Sneakers</li>
													<li>All Shoes</li>
												</ul>
												<ul data-subcategory='subcat-bags'>
													<li>Cross Body Bags</li>
													<li>Luggage + Travel</li>
													<li>Shoulder Bags</li>
													<li>Tote Bags</li>
													<li>Weekender</li>
													<li>All Bags</li>
												</ul>
												<ul data-subcategory='subcat-accessories'>
													<li>Belts</li>
													<li>Hats</li>
													<li>Jewelry</li>
													<li>Scarves</li>
													<li>
														Sunglasses + Readers
													</li>
													<li>All Accessories</li>
												</ul>
											</div>
										</div>
									</li>
									<li
										id='nav-item__men'
										className='nav-list__item text-uppercase'>
										<a href='/category'>Men</a>
										<div className='submenu__men submenu-container row'>
											<div className='col-md-4 pos--relative'>
												<ul>
													<li
														id='subcat-clothing'
														onMouseOver={
															this.handleHover
														}>
														Clothing
													</li>
													<li
														id='subcat-shoes'
														onMouseOver={
															this.handleHover
														}>
														Shoes
													</li>
													<li
														id='subcat-accessories'
														onMouseOver={
															this.handleHover
														}>
														Accessories
													</li>
													<li
														onMouseOver={
															this.handleHover
														}>
														All Men
													</li>
												</ul>
											</div>
											<div className='col-md-4 pos--relative'>
												<ul data-subcategory='subcat-clothing'>
													<li>All Apparel</li>
													<li>Activewear</li>
													<li>T-Shirts</li>
													<li>Swimwear</li>
													<li>
														Pajamas + Loungewear
													</li>
													<li>Underwear</li>
													<li>All Clothing</li>
												</ul>
												<ul data-subcategory='subcat-shoes'>
													<li>Boots</li>
													<li>Sneakers</li>
													<li>Loafers</li>
													<li>All Shoes</li>
												</ul>
												<ul data-subcategory='subcat-accessories'>
													<li>Sunglasses</li>
													<li>All Accessories</li>
												</ul>
											</div>
										</div>
									</li>
									<li
										id='nav-item__kids'
										className='nav-list__item text-uppercase'>
										<a href='/category'>Kids</a>
										<div className='submenu__kids submenu-container row'>
											<div className='col-md-4 pos--relative'>
												<ul>
													<li
														id='subcat-baby-boys'
														onMouseOver={
															this.handleHover
														}>
														Baby Boys
													</li>
													<li
														id='subcat-baby-girls'
														onMouseOver={
															this.handleHover
														}>
														Baby Girls
													</li>
													<li
														id='subcat-nursery'
														onMouseOver={
															this.handleHover
														}>
														Nursery
													</li>
													<li
														onMouseOver={
															this.handleHover
														}>
														All Kids
													</li>
												</ul>
											</div>
											<div className='col-md-4 pos--relative'>
												<ul data-subcategory='subcat-baby-boys'>
													<li>All Baby Boys</li>
												</ul>
												<ul data-subcategory='subcat-baby-girls'>
													<li>All Baby Girls</li>
												</ul>
												<ul data-subcategory='subcat-nursery'>
													<li>Baby Boy Bibs</li>
													<li>Baby Girl Bibs</li>
													<li>All Nursery</li>
												</ul>
											</div>
										</div>
									</li>
									<li
										id='nav-item__beauty'
										className='nav-list__item text-uppercase'>
										<a href='/category'>Beauty</a>
										<div className='submenu__beauty submenu-container row'>
											<div className='col-md-4 pos--relative'>
												<ul>
													<li
														id='subcat-bath-body'
														onMouseOver={
															this.handleHover
														}>
														Bath + Body
													</li>
													<li
														id='subcat-haircare'
														onMouseOver={
															this.handleHover
														}>
														Haircare
													</li>
													<li
														id='subcat-skincare'
														onMouseOver={
															this.handleHover
														}>
														Skincare
													</li>
													<li
														id='subcat-wellness'
														onMouseOver={
															this.handleHover
														}>
														Wellness
													</li>
													<li
														onMouseOver={
															this.handleHover
														}>
														All Beauty
													</li>
												</ul>
											</div>
											<div className='col-md-4 pos--relative'>
												<ul data-subcategory='subcat-bath-body'>
													<li>All Bath + Body</li>
												</ul>
												<ul data-subcategory='subcat-haircare'>
													<li>All Haircare</li>
												</ul>
												<ul data-subcategory='subcat-skincare'>
													<li>All Skincare</li>
												</ul>
												<ul data-subcategory='subcat-wellness'>
													<li>All Wellness</li>
												</ul>
											</div>
										</div>
									</li>
									<li
										id='nav-item__home'
										className='nav-list__item text-uppercase'>
										<a href='/category'>Home Goods</a>
										<div className='submenu__home submenu-container row'>
											<div className='col-md-4 pos--relative'>
												<ul>
													<li
														id='subcat-bedding'
														onMouseOver={
															this.handleHover
														}>
														Bedding
													</li>
													<li
														id='subcat-candles'
														onMouseOver={
															this.handleHover
														}>
														Candles
													</li>
													<li
														id='subcat-art-decor'
														onMouseOver={
															this.handleHover
														}>
														Art + Decor
													</li>
													<li
														id='subcat-kitchen-bar'
														onMouseOver={
															this.handleHover
														}>
														Kitchen + Bar
													</li>
													<li
														id='subcat-outdoors'
														onMouseOver={
															this.handleHover
														}>
														Outdoors
													</li>
													<li
														id='subcat-purposeful-cleaning'
														onMouseOver={
															this.handleHover
														}>
														Purposeful Cleaning
													</li>
													<li
														onMouseOver={
															this.handleHover
														}>
														All Home
													</li>
												</ul>
											</div>
											<div className='col-md-4 pos--relative'>
												<ul data-subcategory='subcat-bedding'>
													<li>All Bedding</li>
												</ul>
												<ul data-subcategory='subcat-candles'>
													<li>All Candles</li>
												</ul>
												<ul data-subcategory='subcat-art-decor'>
													<li>All Art + Decor</li>
												</ul>
												<ul data-subcategory='subcat-kitchen-bar'>
													<li>All Kitchen + Bar</li>
												</ul>
												<ul data-subcategory='subcat-outdoors'>
													<li>Outdoors</li>
												</ul>
												<ul data-subcategory='subcat-purposeful-cleaning'>
													<li>Purposeful Cleaning</li>
												</ul>
											</div>
										</div>
									</li>
									<li
										id='nav-item__lifestyle'
										className='nav-list__item text-uppercase'>
										<a href='/category'>Lifestyle</a>
										<div className='submenu__lifestyle submenu-container row'>
											<div className='col-md-4 pos--relative'>
												<ul>
													<li
														id='subcat-books-stationary'
														onMouseOver={
															this.handleHover
														}>
														Books + Stationary
													</li>
													<li
														id='subcat-fun-games'
														onMouseOver={
															this.handleHover
														}>
														Fun + Games
													</li>
													<li
														id='subcat-gift'
														onMouseOver={
															this.handleHover
														}>
														Gift
													</li>
													<li
														id='subcat-wellness'
														onMouseOver={
															this.handleHover
														}>
														Wellness
													</li>
													<li
														id='subcat-beach'
														onMouseOver={
															this.handleHover
														}>
														Beach
													</li>
													<li
														id='subcat-zero-waste'
														onMouseOver={
															this.handleHover
														}>
														Zero Waste
													</li>
													<li
														id='subcat-yoga-mats'
														onMouseOver={
															this.handleHover
														}>
														Yoga Mats
													</li>
													<li
														onMouseOver={
															this.handleHover
														}>
														All Lifsetyle
													</li>
												</ul>
											</div>
											<div className='col-md-4 pos--relative'>
												<ul data-subcategory='subcat-books-stationary'>
													<li>
														All Books + Stationary
													</li>
												</ul>
												<ul data-subcategory='subcat-fun-games'>
													<li>All Fun + Games</li>
												</ul>
												<ul data-subcategory='subcat-gift'>
													<li>All Gift</li>
												</ul>
												<ul data-subcategory='subcat-wellness'>
													<li>All Wellness</li>
												</ul>
												<ul data-subcategory='subcat-beach'>
													<li>All Beach</li>
												</ul>
												<ul data-subcategory='subcat-zero-waste'>
													<li>All Zero Waste</li>
												</ul>
												<ul data-subcategory='subcat-yoga-mats'>
													<li>All Yoga Mats</li>
												</ul>
											</div>
										</div>
									</li>
									<li
										id='nav-item__grocery'
										className='nav-list__item text-uppercase'>
										<a href='/category'>Grocery</a>
										<div className='submenu__grocery submenu-container row'>
											<div className='col-md-4 pos--relative'>
												<ul>
													<li
														id='subcat-coffee'
														onMouseOver={
															this.handleHover
														}>
														Coffee
													</li>
													<li
														onMouseOver={
															this.handleHover
														}>
														All Grocery
													</li>
												</ul>
											</div>
											<div className='col-md-4 pos--relative'>
												<ul data-subcategory='subcat-coffee'>
													<li>All Coffee</li>
												</ul>
											</div>
										</div>
									</li>
									<li
										id='nav-item__about'
										className='nav-list__item text-uppercase'>
										<a href='/'>About Us</a>
										<div className='submenu__about submenu-container row'>
											<div className='col-md-4 pos--relative'>
												<ul>
													<li>
														<a href='/about-us/our-story'>
															Our Story
														</a>
													</li>
													<li>
														<a href='/about-us/our-process'>
															The Etho HQs
														</a>
													</li>
													<li>
														<a href='/about-us/our-team'>
															The Etho Team
														</a>
													</li>
													<li>
														<a href='https://blog.theetho.com'>
															Stories
														</a>
													</li>
												</ul>
											</div>
										</div>
									</li>
									<li className='nav-list__item text-uppercase text-green bold'>
										<a
											className='btn btn--secondary'
											href='https://blog.theetho.com'>
											<span className='btn__text'>
												Blog
											</span>
										</a>
									</li>
								</ul>
							</nav>
							<div className='col-md-2 md-form active-pink-2 pt-2'>
								<input
									className='form-control'
									type='search'
									placeholder='Search'
									aria-label='Search'
								/>
							</div>
						</div>
					</div>
					<div className='row pt-3 pb-3 visible-sm visible-xs'>
						<div className='col-8 align-self-center'>
							<a href='/'>
								<img
									src={Logo}
									alt='The Etho Logo'
									style={{
										maxHeight: '7.5rem'
									}}
								/>
							</a>
						</div>
						<div className='col-4 align-self-center text-right'>
							<div className='mobile-nav__button'>
								<div
									id='cart-icon__container'
									className='mr-4'
									onClick={this.toggleCartDrawer}>
									<FAI icon='shopping-cart' size='lg' />
								</div>
								<div
									id='hamburger-icon__container'
									onClick={this.toggleMobileNav}>
									<div className='hamburger-icon-bar' />
								</div>
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='header-promo text-center'>
							<a href='/landing-page' className='wrap'>
								<p>
									Check Out&nbsp;
									<span className='semi-bold'>
										The Curated!
									</span>
									&nbsp;Click Here to Learn More
								</p>
							</a>
						</div>
					</div>
				</div>
			</section>
		)
	}
}
